import { DependentsState } from '../slices/dependentsSlice';
import { RootState } from '../store';

export const selectDependents = (state: RootState): DependentsState => state.dependents;
